const ENVIRONMENTS = {
  production: {
    BASE_URL: "https://eq.acrossassist.com",
    API_URL: "https://portal.acrossassist.com/api/partner/v1/apb/",
    SHOW_SIDEBAR: false,
  },
  staging: {
    BASE_URL: "https://test3.acrossassist.in",
    API_URL: "https://portal.acrossassist.com/api/partner/v1/apb/",
    SHOW_SIDEBAR: false,
  },
  development: {
    BASE_URL: "http://localhost:3000",
    API_URL: "https://portal.acrossassist.com/api/partner/v1/apb/",
    SHOW_SIDEBAR: false,
  },
};

const getEnvironment = () => {
  const baseUrl = window.location.origin;
  if (baseUrl === ENVIRONMENTS.production.BASE_URL) {
    return "production";
  } else if (baseUrl === ENVIRONMENTS.staging.BASE_URL) {
    return "staging";
  } else if (baseUrl === ENVIRONMENTS.development.BASE_URL) {
    return "development";
  } else {
    // Default to development if not matched
    return "development";
  }
};

const CURRENT_ENV = getEnvironment();

export const URL_CONFIG = {
  ...ENVIRONMENTS[CURRENT_ENV],
};
